import { UUID, } from '@awayjs/core';
var RenderGroup = /** @class */ (function () {
    function RenderGroup(rendererClass) {
        this.materialClassPool = {};
        this.id = UUID.Next();
        this.rendererClass = rendererClass;
    }
    RenderGroup.prototype.requestAbstraction = function (asset) {
        return this.rendererClass;
    };
    RenderGroup.prototype.getRenderer = function (partition) {
        return partition.getAbstraction(this);
    };
    RenderGroup.getInstance = function (rendererClass) {
        return RenderGroup._renderGroupPool[rendererClass.assetType]
            || (RenderGroup._renderGroupPool[rendererClass.assetType] = new RenderGroup(rendererClass));
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderGroup.registerElements = function (renderElementsClass, elementsClass) {
        RenderGroup._renderElementsClassPool[elementsClass.assetType] = renderElementsClass;
    };
    RenderGroup.getRenderElementsClass = function (asset) {
        return RenderGroup._renderElementsClassPool[asset.assetType];
    };
    RenderGroup._renderGroupPool = {};
    RenderGroup._renderElementsClassPool = {};
    return RenderGroup;
}());
export { RenderGroup };
